const STORE_ID = "FERIADOS";

const TYPES = {
  GET_ALL_ITENS: "GET_ALL_ITENS",
  PESQUISA: "PESQUISA",
  ITEMS: "ITEMS",
  SET_ITEMS: "SET_ITEMS",
  SET_ITEM: "SET_ITEM",
  SET_SELECTED_ITEMS: "SET_SELECTED_ITEMS",
  TOTALS: "TOTALS",
  SET_PERMITIONS: "SET_PERMITIONS",
  FERIADO_COPY: "FERIADO_COPY",
  INVALID: "INVALID",
  CLEAN_INVALID: "CLEAN_INVALID",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  CLEAN_REGISTER: "CLEAN_REGISTER",
  CLEAN_SEARCH: "CLEAN_SEARCH",
  FERIADOS: "FERIADOS",
  SET_SEE: "SET_SEE",
};

export { STORE_ID, TYPES };
